import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var VolumeDownIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M14 4.414a2 2 0 012 2v11.172A2 2 0 0112.586 19l-3-3H7a2 2 0 01-2-2v-4a2 2 0 012-2h2.586l3-3A2 2 0 0114 4.414zm0 2l-3.293 3.293A1 1 0 0110 10H7v4h3a1 1 0 01.707.293L14 17.586V6.414zm3.553.692a1 1 0 011.341.447C19.63 9.02 20 10.507 20 12c0 1.493-.371 2.979-1.106 4.447a1 1 0 01-1.788-.894c.599-1.198.894-2.38.894-3.553s-.295-2.355-.894-3.553a1 1 0 01.447-1.341z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
VolumeDownIcon.isCarinaIcon = true;
export default VolumeDownIcon;
